export default {
  id: 38,
  title: 'Target #38 - Not Simply Square',
  url: 'https://cssbattle.dev/play/38',
  colors: ['#293462', '#FFF1C1', '#FE5F55', '#A64942'],
  solution:
    '<a a><a b><style>body{background:linear-gradient(90deg,#FFF1C1 50%,#293462 50%)}a[a],a[b]{position:fixed;top:0;left:200;width:100;height:200;background:linear-gradient(#FE5F55 75%,#A64942 75%)}a[b]{transform:rotate(-90deg) translate(-150px,-150px)}</style>',
}
